<template>
    <div class="sidebar"  v-if="!$parent.isAdminPage($route.path, $route.name)">
        <nav class="sidebar-nav" v-if="userinfo.user_level === 'admin'">
            <ul class="nav">
                <li class="nav-item">
                    <router-link to="/dashboard" exact class="nav-link">
                        <i class="icon-speedometer"></i> Dashboard
                    </router-link>
                </li>
                <li class="nav-item nav-dropdown">
                    <a href="#" class="nav-link nav-dropdown-toggle"><i class="fa fa-exchange"></i>Company</a>
                    <ul class="nav-dropdown-items nav-dropdown-items-left">
                        <li class="nav-item" >
                            <router-link :to="{path: '/company', query: { page: 1 }}" exact class="nav-link">
                                <i class="fa fa-suitcase"></i> View All
                            </router-link>
                        </li>
                        <li class="nav-item" >
                            <router-link :to="{path: '/company/add'}" exact class="nav-link">
                                <i class="fa fa-plus"></i> Add
                            </router-link>
                        </li>
                    </ul>
                </li>
                <li class="nav-item nav-dropdown">
                    <a href="#" class="nav-link nav-dropdown-toggle"><i class="fa fa-exchange"></i>Users</a>
                    <ul class="nav-dropdown-items nav-dropdown-items-left">
                        <li class="nav-item" >
                            <router-link :to="{path: '/usersadmin', query: { page: 1 }}" exact class="nav-link">
                                <i class="fa fa-users"></i> View All
                            </router-link>
                        </li>
                        <li class="nav-item" >
                            <router-link :to="{path: '/usersadmin/add'}" exact class="nav-link">
                                <i class="fa fa-plus"></i> Add
                            </router-link>
                        </li>
                    </ul>
                </li>
            </ul>
        </nav>
        <nav class="sidebar-nav" v-else>
            <!-- START RETAIL execution -->
            <ul class="nav" v-show="current_top_menu === 'retail execution'">
                <li v-if="is_master === true || (is_manager === true || is_client === true)"
                        class="nav-item" :class="{'active-menu': isActiveMenu('(dashboard)')}">
                    <router-link :to="{path: '/retailer-execution', query: { page: 1 }}" exact :class="['nav-link']">
                        <i class="fa fa-chart-bar"></i>Activities
                    </router-link>
                </li>
                <li  v-if="is_master === true || (is_manager === true || is_client === true)"
                        class="nav-item nav-dropdown" :class="{'open': active_actions}" >
                    <a href="#" class="nav-link nav-dropdown-toggle"><i class="fas fa-calendar-plus"></i>Actions</a>
                    <ul class="nav-dropdown-items" :class="{'nav-dropdown-items-left': !active_actions, 'dbimportant': active_actions}" >
                        <li class="nav-item" :class="{'active-menu': isActiveMenu('(visits)')}" v-if="is_master === true || (permissions.indexOf('136') >= 0 && features.indexOf('visit') >= 0)">
                            <router-link :to="{path: '/visits', query: { page: 1 }}" exact class="nav-link">
                                <i class="fa fa-street-view"></i>
                                <span class="nav-title" title="Visits">Visits</span>
                            </router-link>
                        </li>
                        <li class="nav-item" :class="{'active-menu': isActiveMenu('(visit-calendar)')}" v-if="is_master === true || (permissions.indexOf('136') >= 0 && features.indexOf('visit') >= 0)" >
                            <router-link :to="{path: '/visit-calendar', query: { page: 1 }}" exact class="nav-link">
                                <i class="far fa-calendar-alt"></i>
                                <span class="nav-title" title="Visit Calendar">Calendar</span>
                            </router-link>
                        </li>
                    </ul>
                </li>
                <li v-if="is_master === true || (is_manager === true || is_client === true)"
                        class="nav-item nav-dropdown" :class="{'open': active_reports}" >
                    <a href="#" class="nav-link nav-dropdown-toggle"><i class="fas fa-chart-line"></i>Reports</a>
                    <ul class="nav-dropdown-items" :class="{'nav-dropdown-items-left': !active_reports, 'dbimportant': active_reports}" >
                        <li class="nav-item" :class="{'active-menu': isActiveMenu('(visit-report2)')}" v-if="is_master === true || ((features.indexOf('retailer_reports') >= 0)  && is_client === false)">
                            <router-link :to="{path: '/visit-report2', query: { page: 1 }}" exact class="nav-link">
                                <i class="fa fa-shopping-cart"></i>
                                <span class="nav-title" title="Retailer Report">Visit Report</span>
                            </router-link>
                        </li>
                        <li class="nav-item" :class="{'active-menu': isActiveMenu('(photo-gallery-report)')}" v-if="is_master === true || (features.indexOf('retailer_reports') >= 0)">
                            <router-link :to="{path: '/photo-gallery-report', query: { page: 1 }}" exact class="nav-link">
                                <i class="fas fa-images"></i>
                                <span class="nav-title" title="Retailer Report">Photo Gallery Report</span>
                            </router-link>
                        </li>
                        <li class="nav-item" :class="{'active-menu': isActiveMenu('(store-audit-report)')}" v-if="is_master === true || (features.indexOf('store_audit') >= 0)">
                            <router-link :to="{path: '/store-audit-report'}" exact class="nav-link">
                                <i class="far fa-calendar-check"></i>
                                <span class="nav-title" title="Store Audit ">Store Audit </span>
                            </router-link>
                        </li>
                        <li class="nav-item" :class="{'active-menu': isActiveMenu('(task-report)')}" v-if="is_master === true || (permissions.indexOf('140') >= 0)" >

                            <router-link :to="{path: '/task-report'}" exact class="nav-link">
                                <i class="fa fa-tasks"></i>
                                <span class="nav-title" title="Task Report">Task Report</span>
                            </router-link>
                        </li>
                        <li class="nav-item" :class="{'active-menu': isActiveMenu('(historical-taskreport)')}" v-if="is_master === true || (permissions.indexOf('140') >= 0)" >
                            <router-link :to="{path: '/historical-taskreport'}" exact class="nav-link">
                                <i class="fa fa-history"></i>
                                <span class="nav-title" title="Historical Report">Historical Report</span>
                            </router-link>
                        </li>
                        <li class="nav-item" :class="{'active-menu': isActiveMenu('(no-visit-location-report)')}" >
                            <router-link :to="{path: '/no-visit-location-report?page=1'}" class="nav-link" >
                                <i class="fas fa-thumbtack"></i> Unplanned Visit
                            </router-link>
                        </li>
                        <li class="nav-item" :class="{'active-menu': isActiveMenu('(uncompleted-store-visits)')}" v-if="is_master === true || (permissions.indexOf('140') >= 0)" >
                            <router-link :to="{path: '/uncompleted-store-visits', query: { page: 1 }}" exact class="nav-link">
                                <i class="far fa-calendar-times"></i>
                                <span class="nav-title" title="Uncompleted Visits">Uncompleted Visits</span>
                            </router-link>
                        </li>
                        <li v-if="is_manager === true" class="nav-item" :class="{'active-menu': isActiveMenu('(master-visit-report)')}" >
                            <router-link :to="{path: '/master-visit-report'}" exact class="nav-link">
                                <i class="fas fa-list"></i>
                                <span class="nav-title" title="Master Report">Master Report</span>
                            </router-link>
                        </li>
                        <li v-if="is_manager === true" class="nav-item" :class="{'active-menu': isActiveMenu('(merchandiser-visit-count-report)')}" >
                            <router-link :to="{path: '/merchandiser-visit-count-report', query: { page: 1 }}" exact class="nav-link">
                                <i class="fas fa-list"></i>
                                <span class="nav-title" title="Master Report">Merchandiser Visit Count Report</span>
                            </router-link>
                        </li>
                    </ul>
                </li>
                <li v-if="is_manager === true"
                        class="nav-item nav-dropdown" :class="{'open': active_locations}" >
                    <a href="#" class="nav-link nav-dropdown-toggle"><i class="fas fa-map-marked-alt"></i>Locations</a>
                    <ul class="nav-dropdown-items" :class="{'nav-dropdown-items-left': !active_locations, 'dbimportant': active_locations}" >
                        <!-- location_read = 12 -->
                        <li class="nav-item" :class="{'active-menu': isActiveMenu('(locations)')}" v-if="is_master === true || (permissions.indexOf('12') >= 0 && features.indexOf('locations') >= 0)">
                            <router-link :to="{path: '/locations', query: { page: 1 }}" exact class="nav-link">
                                <i class="fa fa-list"></i> Locations
                            </router-link>
                        </li>
                        <!-- location_read = 12 -->
                        <li class="nav-item" :class="{'active-menu': isActiveMenu('(location-map)')}" v-if="is_master === true || (permissions.indexOf('12') >= 0 && features.indexOf('location_map') >= 0)">
                            <router-link :to="{path: '/location-map'}" exact class="nav-link">
                                <i class="fas fa-map-marker-alt"></i> Location Map
                            </router-link>
                        </li>
                    </ul>
                </li>
                <li  v-if="is_master === true || (is_manager === true)"
                        class="nav-item" :class="{'active-menu': isActiveMenu('(merchandisers)')}" >
                    <router-link :to="{path: '/merchandisers', query: { page: 1 }}" exact :class="['nav-link', {'active': isActiveMenu(merchandiser_paths)}]">
                        <i class="fas fa-user-tie"></i> Merchandisers
                    </router-link>
                </li>
                <!-- task_read = 116 -->
                <li v-if="is_master === true || is_manager === true"
                        class="nav-item" :class="{'active-menu': isActiveMenu('(tasks)')}" >
                    <router-link :to="{path: '/tasks', query: { page: 1 }}" exact class="nav-link">
                        <i class="fas fa-list-ol"></i> Tasks
                    </router-link>
                </li>

            </ul>
            <!-- END RETAIL EXECUTION -->
            <!-- START STOCK -->
            <ul class="nav" v-show="current_top_menu === 'stock-management-dashboard'">
                <li v-if="is_master === true || (is_manager === true || is_client === true && (plan === 2 || plan === 3 || plan === 4))"
                        class="nav-item" :class="{'active-menu': isActiveMenu('(dashboard)')}">
                    <router-link to="/stock-management-dashboard" exact class="nav-link">
                        <i class="fa fa-chart-bar"></i> Activities
                    </router-link>
                </li>
                <li v-if="is_master === true || (is_manager === true || is_client === true && (plan === 2 || plan === 3 || plan === 4))"
                        class="nav-item nav-dropdown" :class="{'open': active_actions}" >
                    <a href="#" class="nav-link nav-dropdown-toggle"><i class="fas fa-calendar-plus"></i>Actions</a>
                    <ul class="nav-dropdown-items" :class="{'nav-dropdown-items-left': !active_actions, 'dbimportant': active_actions}" >
                        <li class="nav-item" :class="{'active-menu': isActiveMenu('(visits)')}" v-if="is_master === true || (permissions.indexOf('136') >= 0 && features.indexOf('visit') >= 0)">
                            <router-link :to="{path: '/visits', query: { page: 1 }}" exact class="nav-link">
                                <i class="fa fa-street-view"></i>
                                <span class="nav-title" title="Visits">Visits</span>
                            </router-link>
                        </li>
                        <li class="nav-item" :class="{'active-menu': isActiveMenu('(visit-calendar)')}" v-if="is_master === true || (permissions.indexOf('136') >= 0 && features.indexOf('visit') >= 0)" >
                            <router-link :to="{path: '/visit-calendar', query: { page: 1 }}" exact class="nav-link">
                                <i class="far fa-calendar-alt"></i>
                                <span class="nav-title" title="Visit Calendar">Calendar</span>
                            </router-link>
                        </li>
                    </ul>
                </li>
                <li v-if="is_manager === true || is_client === true && (plan === 2 || plan === 3 || plan === 4)"
                        class="nav-item nav-dropdown" :class="{'open': active_reports}" >
                    <a href="#" class="nav-link nav-dropdown-toggle"><i class="fas fa-chart-line"></i>Reports</a>
                    <ul class="nav-dropdown-items" :class="{'nav-dropdown-items-left': !active_reports, 'dbimportant': active_reports}" >
                        <li class="nav-item" :class="{'active-menu': isActiveMenu('(visit-report2)')}" v-if="is_master === true || ((features.indexOf('retailer_reports') >= 0) && is_client === false)  ">
                            <router-link :to="{path: '/visit-report2', query: { page: 1 }}" exact class="nav-link">
                                <i class="fa fa-shopping-cart"></i>
                                <span class="nav-title" title="Retailer Report">Visit Report</span>
                            </router-link>
                        </li>
                        <li v-if="is_master === true || is_manager === true || is_client === true" class="nav-item" :class="{'active-menu': isActiveMenu('(stock-take-reports)')}" >
                            <router-link :to="{path: '/stock-take-reports', query: { page: 1 }}" exact class="nav-link">
                                <i class="fas fa-box"></i> Stock Take Report
                            </router-link>
                        </li>
                        <li v-if="is_master === true || is_manager === true || is_client === true" class="nav-item" :class="{'active-menu': isActiveMenu('(stock-take-report-all-location)')}" >
                            <router-link :to="{path: '/stock-take-report-all-location', query: { page: 1 }}" exact class="nav-link">
                                <i class="fas fa-box"></i> Stock Take Report for All Locations
                            </router-link>
                        </li>
                        <li v-if="is_master === true || is_manager === true || is_client === true" class="nav-item" :class="{'active-menu': isActiveMenu('(stock-take-photo-reports)')}" >
                            <router-link :to="{path: '/stock-take-photo-reports', query: { page: 1 }}" exact class="nav-link">
                                <i class="fas fa-images"></i> Photo Gallery Report
                            </router-link>
                        </li>

                        <li v-if="is_master === true || is_manager === true || is_client === true" class="nav-item" :class="{'active-menu': isActiveMenu('(order-form-report)')}" >
                            <router-link :to="{path: '/order-form-report', query: { page: 1 }}" exact class="nav-link">
                                <i class="far fa-list-alt"></i> Order Form Report
                            </router-link>
                        </li>

                        <!-- visitreport_read = 140 -->
                        <li v-if="is_master === true || ((is_manager === true || is_client === true) && (plan === 3 || plan === 4))" class="nav-item" :class="{'active-menu': isActiveMenu('(planogram-visit-reports)')}" >
                            <router-link :to="{path: '/planogram-visit-reports', query: { page: 1 }}" exact class="nav-link">
                                <i class="far fa-eye"></i>
                                <span class="nav-title" title="Planogram Report">Planogram Report</span>
                            </router-link>
                        </li>
                        <li v-if="is_master === true || is_manager === true || is_client === true" class="nav-item" :class="{'active-menu': isActiveMenu('(planogram-reports-all-location)')}" >
                            <router-link :to="{path: '/planogram-reports-all-location', query: { page: 1 }}" exact class="nav-link">
                                <i class="fas fa-box"></i> Planogram Report for All Locations
                            </router-link>
                        </li>

                        <li v-if="is_master === true || ((is_manager === true || is_client === true) && (plan === 3 || plan === 4)) " class="nav-item" :class="{'active-menu': isActiveMenu('(oos-report)')}" >
                            <router-link :to="{path: '/oos-report?page=1'}" class="nav-link" v-if="is_master === true || features.indexOf('sales') >= 0">
                                <i class="far fa-times-circle"></i> OOS Report
                            </router-link>
                        </li>
                        <li v-if="is_master === true || ((is_manager === true || is_client===true) && plan === 4)" class="nav-item" :class="{'active-menu': isActiveMenu('(stock-take-management-reports)')}" >
                            <router-link :to="{path: '/stock-take-management-reports?page=1'}" class="nav-link" v-if="is_master === true || features.indexOf('promoters') >= 0">
                                <i class="fas fa-user"></i> Promoter Stock Take
                            </router-link>
                        </li>
                        <li v-if="is_master === true || ((is_manager === true || is_client===true) && plan === 4)" class="nav-item" :class="{'active-menu': isActiveMenu('(stock-request-management-reports)')}" >
                            <router-link :to="{path: '/stock-request-management-reports?page=1'}" class="nav-link" v-if="is_master === true || features.indexOf('promoters') >= 0">
                                <i class="far fa-plus-square"></i> Stock Request
                            </router-link>
                        </li>
                        <li v-if="is_master === true || ((is_manager === true || is_client===true) && plan === 4)" class="nav-item" :class="{'active-menu': isActiveMenu('(stock-receipt-management-reports)')}" >
                            <router-link :to="{path: '/stock-receipt-management-reports?page=1'}" class="nav-link" v-if="is_master === true || features.indexOf('promoters') >= 0">
                                <i class="fas fa-clipboard-check"></i> Stock Receipt
                            </router-link>
                        </li>
                        <li v-if="is_master === true || ((is_manager === true || is_client===true) && plan === 4)" class="nav-item" :class="{'active-menu': isActiveMenu('(stock-transfer-management-reports)')}" >
                            <router-link :to="{path: '/stock-transfer-management-reports?page=1'}" class="nav-link" v-if="is_master === true || features.indexOf('promoters') >= 0">
                                <i class="fas fa-exchange-alt"></i> Stock Transfer
                            </router-link>
                        </li>
                        <li v-if="is_master === true || ((is_manager === true || is_client===true) && plan === 4)" class="nav-item" :class="{'active-menu': isActiveMenu('(stock-receipt-erp-management-reports)')}" >
                            <router-link :to="{path: '/stock-receipt-erp-management-reports?page=1'}" class="nav-link" v-if="is_master === true || features.indexOf('promoters') >= 0">
                                <i class="fas fa-clipboard-check"></i> Stock Receipt ERP
                            </router-link>
                        </li>
                        <li v-if="is_master === true || (is_manager === true && plan === 4)" class="nav-item" :class="{'active-menu': isActiveMenu('(discrepancy-report)')}"  >
                            <router-link :to="{path: '/discrepancy-report'}" exact class="nav-link">
                                <i class="fas fa-balance-scale"></i>
                                <span class="nav-title" title="Discrepancy Report">Discrepancy Report</span>
                            </router-link>
                        </li>
                    </ul>
                </li>
                <li v-if="is_master === true || is_manager === true"
                    class="nav-item nav-dropdown" :class="{'open': active_inventories}" >
                  <a href="#" class="nav-link nav-dropdown-toggle"><i class="fas fa-map-marked-alt"></i>Stock</a>
                  <ul class="nav-dropdown-items" :class="{'nav-dropdown-items-left': !active_inventories, 'dbimportant': active_inventories}" >
                    <li class="nav-item" :class="{'active-menu': isActiveMenu('(inventories)')}" v-if="is_master === true || (permissions.indexOf('12') >= 0 && features.indexOf('inventories') >= 0)">
                      <router-link :to="{path: '/inventories', query: { page: 1 }}" exact class="nav-link">
                        <i class="fa fa-list"></i> Stock management
                      </router-link>
                    </li>
                  </ul>
                </li>
                
                <li v-if="is_master === true || is_manager === true"
                    class="nav-item nav-dropdown" :class="{'open': active_inventories}" >
                    <router-link :to="{path: '/stock-discrepancies', query: { page: 1 }}" exact class="nav-link">
                        <i class="fa fa-list"></i> Stock Discrepancy Report
                    </router-link>
                </li>
                <li v-if="is_master === true || is_manager === true"
                        class="nav-item nav-dropdown" :class="{'open': active_locations}" >
                    <a href="#" class="nav-link nav-dropdown-toggle"><i class="fas fa-map-marked-alt"></i>Locations</a>
                    <ul class="nav-dropdown-items" :class="{'nav-dropdown-items-left': !active_locations, 'dbimportant': active_locations}" >
                        <!-- location_read = 12 -->
                        <li class="nav-item" :class="{'active-menu': isActiveMenu('(locations)')}" v-if="is_master === true || (permissions.indexOf('12') >= 0 && features.indexOf('locations') >= 0)">
                            <router-link :to="{path: '/locations', query: { page: 1 }}" exact class="nav-link">
                                <i class="fa fa-list"></i> Locations
                            </router-link>
                        </li>
                        <!-- location_read = 12 -->
                        <li class="nav-item" :class="{'active-menu': isActiveMenu('(location-map)')}" v-if="is_master === true || (permissions.indexOf('12') >= 0 && features.indexOf('location_map') >= 0)">
                            <router-link :to="{path: '/location-map'}" exact class="nav-link">
                                <i class="fas fa-map-marker-alt"></i> Location Map
                            </router-link>
                        </li>
                    </ul>
                </li>
                <li v-if="is_master === true || is_manager === true"
                        class="nav-item" :class="{'active-menu': isActiveMenu('(merchandisers)')}" >
                    <router-link :to="{path: '/merchandisers', query: { page: 1 }}" exact :class="['nav-link', {'active': isActiveMenu(merchandiser_paths)}]">
                        <i class="fas fa-user-tie"></i> Merchandisers
                    </router-link>
                </li>
                <!-- task_read = 116 -->
                <li v-if="is_master === true || is_manager === true"
                        class="nav-item" :class="{'active-menu': isActiveMenu('(tasks)')}" >
                    <router-link :to="{path: '/tasks', query: { page: 1 }}" exact class="nav-link">
                        <i class="fas fa-list-ol"></i> Tasks
                    </router-link>
                </li>
                <li v-if="is_master === true || is_manager === true"
                        class="nav-item" :class="{'active-menu': isActiveMenu('(sales)')}" >
                    <router-link :to="{path: '/sales', query: { page: 1 }}" exact class="nav-link">
                        <i class="fas fa-dollar"></i> Sales
                    </router-link>
                </li>

            </ul>
            <!-- END STOCK -->
            <!-- START SALES -->
            <ul class="nav" v-show="current_top_menu === 'sales dashboard'">
                <li v-if="is_master === true || ((is_manager === true || is_client===true) && plan === 4)"
                        class="nav-item" :class="{'active-menu': isActiveMenu('(dashboard)')}">
                    <router-link :to="{path: '/sales-dashboard', query: { page: 1 }}" exact :class="['nav-link']">
                        <i class="fa fa-chart-bar"></i>Activities
                    </router-link>
                </li>
                <li v-if="is_master === true || (is_manager === true && plan === 4)"
                        class="nav-item nav-dropdown" :class="{'open': active_actions}" >
                    <a href="#" class="nav-link nav-dropdown-toggle"><i class="fas fa-calendar-plus"></i>Actions</a>
                    <ul class="nav-dropdown-items" :class="{'nav-dropdown-items-left': !active_actions, 'dbimportant': active_actions}" >
                        <li :class="['nav-item', 'link-master-data', {'active-menu': isActiveMenu('(promoter-rosters)')}]" v-if="is_master === true || (permissions.indexOf('156') >= 0 && features.indexOf('promoters') >= 0)">
                            <router-link :to="{path: '/promoter-rosters', query: { page: 1 }}" exact :class="['nav-link', {'active': isActiveMenu(promoter_roster_path)}]">
                                <i class="fa fa-street-view"></i> Roster
                            </router-link>
                        </li>
                        <li class="nav-item" :class="{'active-menu': isActiveMenu('(promoter-calendar)')}" v-if="is_master === true || (permissions.indexOf('156') >= 0 && features.indexOf('promoters') >= 0)" >
                            <router-link :to="{path: '/promoter-calendar', query: { page: 1 }}" exact class="nav-link">
                                <i class="far fa-calendar-alt"></i>
                                <span class="nav-title" title="Roster Calendar">Roster Calendar</span>
                            </router-link>
                        </li>
                    </ul>
                </li>
                <li v-if="is_master === true || ((is_manager === true || is_client===true) && plan === 4)"
                        class="nav-item nav-dropdown" :class="{'open': active_reports}" >
                    <a href="#" class="nav-link nav-dropdown-toggle"><i class="fas fa-chart-line"></i>Reports</a>
                    <ul class="nav-dropdown-items" :class="{'nav-dropdown-items-left': !active_reports, 'dbimportant': active_reports}" >
                        <li :class="['nav-item', 'link-master-data', {'active-menu': isActiveMenu('(promoter-roster-report)')}]" v-if="is_master === true || (permissions.indexOf('156') >= 0 && features.indexOf('promoters') >= 0)">
                            <router-link :to="{path: '/promoter-roster-report', query: { page: 1 }}" exact class="nav-link">
                                <i class="fas fa-user-clock"></i> Attendance
                            </router-link>
                        </li>
                        <li :class="['nav-item', 'link-master-data', {'active-menu': isActiveMenu('(non-clocked-employee-reports)')}]" v-if="is_master === true || (permissions.indexOf('156') >= 0 && features.indexOf('promoters') >= 0)">
                            <router-link :to="{path: '/non-clocked-employee-reports', query: { page: 1 }}" exact class="nav-link">
                                <i class="fas fa-exclamation-circle"></i> Non Clocked
                            </router-link>
                        </li>
                        <li class="nav-item" :class="{'active-menu': isActiveMenu('(salesreport)')}" v-if="is_master === true || (permissions.indexOf('158') >= 0 && features.indexOf('sales') >= 0)">
                            <router-link :to="{path: '/salesreport?page=1'}" class="nav-link" v-if="is_master === true || features.indexOf('sales') >= 0">
                                <i class="fas fa-file-invoice-dollar"></i>Sales Report
                            </router-link>
                        </li>
                        <li class="nav-item" :class="{'active-menu': isActiveMenu('(commission-report)')}" v-if="is_client !== true">
                            <router-link :to="{path: '/commission-report', query: { page: 1 }}" exact class="nav-link">
                                <i class="fas fa-piggy-bank"></i>
                                <span class="nav-title" title="Commission Report">Commission Report</span>
                            </router-link>
                        </li>
                        <li class="nav-item" :class="{'active-menu': isActiveMenu('(sampling-reports)')}" v-if="sampling === 1 && is_client !== true">
                            <router-link :to="{path: '/sampling-reports', query: { page: 1 }}" exact class="nav-link">
                                <i class="fas fa-piggy-bank"></i>
                                <span class="nav-title" title="Commission Report">Sampling Report</span>
                            </router-link>
                        </li>
                        <li class="nav-item" :class="{'active-menu': isActiveMenu('(customers)')}" v-if="is_client !== true">
                            <router-link :to="{path: '/customers', query: { page: 1 }}" exact class="nav-link">
                                <i class="fas fa-users"></i>
                                <span class="nav-title" title="CRM">CRM</span>
                            </router-link>
                        </li>
                    </ul>
                </li>
                <li v-if="is_master === true || is_manager === true"
                        class="nav-item nav-dropdown" :class="{'open': active_locations}" >
                    <a href="#" class="nav-link nav-dropdown-toggle"><i class="fas fa-map-marked-alt"></i>Locations</a>
                    <ul class="nav-dropdown-items" :class="{'nav-dropdown-items-left': !active_locations, 'dbimportant': active_locations}" >
                        <!-- location_read = 12 -->
                        <li class="nav-item" :class="{'active-menu': isActiveMenu('(locations)')}" v-if="is_master === true || (permissions.indexOf('12') >= 0 && features.indexOf('locations') >= 0)">
                            <router-link :to="{path: '/locations', query: { page: 1 }}" exact class="nav-link">
                                <i class="fa fa-list"></i> Locations
                            </router-link>
                        </li>
                        <!-- location_read = 12 -->
                        <li class="nav-item" :class="{'active-menu': isActiveMenu('(location-map)')}" v-if="is_master === true || (permissions.indexOf('12') >= 0 && features.indexOf('location_map') >= 0)">
                            <router-link :to="{path: '/location-map'}" exact class="nav-link">
                                <i class="fas fa-map-marker-alt"></i> Location Map
                            </router-link>
                        </li>
                    </ul>
                </li>
                <li v-if="is_master === true || is_manager === true"
                    :class="['nav-item', 'link-master-data', {'active-menu': isActiveMenu('(promoters)')}]" >
                    <router-link :to="{path: '/promoters', query: { page: 1 }}" exact :class="['nav-link', {'active': isActiveMenu(promoter_path)}]">
                        <i class="fas fa-user-tie"></i> Promoters
                    </router-link>
                </li>
                <li class="nav-item nav-dropdown" :class="{'open': active_sales_settings}"
                        v-if="is_master === true || (is_manager === true && ((permissions.indexOf('168') >= 0 || permissions.indexOf('172') >= 0)
                         && features.indexOf('sales') >= 0 && userinfo.client_id === null))">
                    <a href="#" class="nav-link nav-dropdown-toggle"><i class="fas fa-dollar-sign"></i>Sales Targets</a>
                    <ul class="nav-dropdown-items " :class="{'nav-dropdown-items-left': !active_sales_settings, 'dbimportant': active_sales_settings}" style="top:auto;bottom:0">
                        <li class="nav-item" :class="{'active-menu': isActiveMenu('(sales-target-location)')}" v-if="is_master === true || (userinfo.client_id === null && permissions.indexOf('168') >= 0 && features.indexOf('sales') >= 0)">
                            <router-link :to="{path: '/sales-target-location?page=1'}" class="nav-link">
                                <i class="fas fa-map-pin"></i> Per Location
                            </router-link>
                        </li>
                        <li class="nav-item" :class="{'active-menu': isActiveMenu('(sales-target-promoter)')}" v-if="is_master === true || (userinfo.client_id === null && permissions.indexOf('172') >= 0 && features.indexOf('sales') >= 0)">
                            <router-link :to="{path: '/sales-target-promoter?page=1'}" class="nav-link">
                                <i class="fas fa-user-tag"></i> Per Promoter
                            </router-link>
                        </li>
                    </ul>
                </li>

            </ul>
            <!-- END SALES -->
            <!-- START SETTINGS  -->
            <ul class="nav" v-show="current_top_menu === 'settings' && is_manager === true">
                <li v-if="is_master === true || is_manager === true"
                        class="nav-item" :class="{'active-menu': isActiveMenu('(dashboard)')}">
                    <router-link to="/settings" exact class="nav-link">
                        <i class="fas fa-cogs"></i> Company Settings
                    </router-link>
                </li>
                <li v-if="is_master === true || is_manager === true"
                        class="nav-item nav-dropdown" :class="{'open': active_manage_users}" >
                    <a href="#" class="nav-link nav-dropdown-toggle"><i class="fas fa-users-cog"></i>Manage Users</a>
                    <ul class="nav-dropdown-items" :class="{'nav-dropdown-items-left': !active_manage_users, 'dbimportant': active_manage_users}" >
                        <li class="nav-item" :class="{'active-menu': isActiveMenu('(/users)')}" v-if="is_master === true || permissions.indexOf('1') >= 0">
                            <router-link :to="{path: '/users', query: { page: 1 }}" exact :class="['nav-link',{'active': isActiveMenu(active_company_settings)}] ">
                                <i class="fa fa-users"></i> Users
                            </router-link>
                        </li>
                        <li class="nav-item" :class="{'active-menu': isActiveMenu('(clientusers)')}" v-if="is_master === true || permissions.indexOf('1') >= 0">
                            <router-link :to="{path: '/clientusers', query: { page: 1 }}" exact :class="['nav-link',{'active': isActiveMenu(clientusers_path)}] ">
                                <i class="fas fa-user-lock"></i> Clients
                            </router-link>
                        </li>
                        <li class="nav-item" :class="{'active-menu': isActiveMenu('(assign-supervisor)')}" v-if="(is_master === true || permissions.indexOf('1') >= 0) && is_supervisor === false">
                            <router-link :to="{path: '/assign-supervisor', query: { page: 1 }}" exact :class="['nav-link',{'active': isActiveMenu(assignsupervisor_path)}] ">
                                <i class="fas fa-user-lock"></i> Assign Supervisor
                            </router-link>
                        </li>
                    </ul>
                </li>
                <li v-if="is_master === true || is_manager === true"
                        class="nav-item nav-dropdown" :class="{'open': active_location_settings}" >
                    <a href="#" class="nav-link nav-dropdown-toggle"><i class="fas fa-sliders-h"></i>Location Settings</a>
                    <ul class="nav-dropdown-items" :class="{'nav-dropdown-items-left': !active_location_settings, 'dbimportant': active_location_settings}" >
                        <li class="nav-item" :class="{'active-menu': isActiveMenu('(clients)')}" v-if="is_master === true || (permissions.indexOf('16') >= 0 && features.indexOf('clients') >= 0)">
                            <router-link :to="{path: '/clients', query: { page: 1 }}"
                                         exact  :class="['nav-link', {'active': isActiveMenu(client_paths)}]" >
                                <i class="icon-user-follow"></i> Clients
                            </router-link>
                        </li>
                        <li class="nav-item" :class="{'active-menu': isActiveMenu('(retailers)')}" v-if="is_master === true || (permissions.indexOf('84') >= 0 && features.indexOf('retailers') >= 0)">
                            <router-link :to="{path: '/retailers', query: { page: 1 }}" exact
                                         :class="['nav-link', {'active': isActiveMenu(retailers_paths)}]" >
                                <i class="glyphicons glyphicons-industrial-zone"></i> Retailers
                            </router-link>
                        </li>
                        <li :class="['nav-item', 'link-master-data', {'active-menu': isActiveMenu('(planograms)')}]" v-if="is_master === true || permissions.indexOf('188') >= 0 ">
                            <router-link :to="{path: '/planograms', query: { page: 1 }}" exact :class="['nav-link', {'active': isActiveMenu(planogram_path)}]">
                                <i class="fa fa-image"></i> Planogram Pictures
                            </router-link>
                        </li>
                    </ul>
                </li>
                <li v-if="is_master === true || (is_manager === true && (plan === 2 || plan === 3 || plan === 4))"
                        class="nav-item nav-dropdown" :class="{'open': active_product_settings}" >
                    <a href="#" class="nav-link nav-dropdown-toggle"><i class="fas fa-toolbox"></i>Product Settings</a>
                    <ul class="nav-dropdown-items" :class="{'nav-dropdown-items-left': !active_product_settings, 'dbimportant': active_product_settings}" >
                        <li :class="['nav-item', 'link-master-data', {'active-menu': isActiveMenu('(product-packings)')}, {'open': isActiveMenu(productpacking_paths)}]" v-if="is_master === true || (permissions.indexOf('68') >= 0 && features.indexOf('product_packing') >= 0)">
                            <router-link :to="{path: '/product-packings', query: { page: 1 }}" exact :class="['nav-link', {'active': isActiveMenu(productpacking_paths)}]">
                                <i class="fas fa-box"></i> Packings
                            </router-link>
                        </li>
                        <!-- productcategory_read = 8 -->
                        <li :class="['nav-item', 'link-master-data', {'active-menu': isActiveMenu('(product-categories)')}, {'open': isActiveMenu(productcategory_paths)}]" v-if="is_master === true || (permissions.indexOf('8') >= 0 && features.indexOf('product_category') >= 0)">
                            <router-link :to="{path: '/product-categories', query: { page: 1 }}" :class="['nav-link', {'active': isActiveMenu(productcategory_paths)}]">
                                <i class="icon-handbag"></i> Categories
                            </router-link>
                        </li>
                        <!-- productbrand_read = 60 -->
                        <li :class="['nav-item', 'link-master-data', {'active-menu': isActiveMenu('(product-brands)')}, {'open': isActiveMenu(productbrand_paths)}]" v-if="is_master === true || (permissions.indexOf('60') >= 0 && features.indexOf('product_brand') >= 0)">
                            <router-link :to="{path: '/product-brands', query: { page: 1 }}" exact :class="['nav-link', {'active': isActiveMenu(productbrand_paths)}]">
                                <i class="fa fa-shopping-bag"></i> Brands
                            </router-link>
                        </li>
                        <li :class="['nav-item', 'link-master-data', {'active-menu': isActiveMenu('(products)')}, {'open': isActiveMenu(product_paths)}]" v-if="is_master === true || (permissions.indexOf('4') >= 0 && features.indexOf('products') >= 0)">
                            <router-link :to="{path: '/products', query: { page: 1 }}" exact :class="['nav-link', {'active': isActiveMenu(product_paths)}]">
                                <i class="glyphicons glyphicons-shopping-cart"></i> Products
                            </router-link>
                        </li>
                        <!-- storemodel_read = 108 -->
                        <li class="nav-item" :class="{'active-menu': isActiveMenu('(store-model)')}" v-if="is_master === true || (permissions.indexOf('108') >= 0  && features.indexOf('store_model') >= 0)">
                            <router-link :to="{path: '/store-model', query: { page: 1 }}" exact
                                         :class="['nav-link', {'active': isActiveMenu(store_model_paths)}]">
                                <i class="fas fa-store"></i>Store Models
                            </router-link>
                        </li>
                        <!-- productpricelist_read = 144 -->
                        <li :class="['nav-item', 'link-master-data', {'active-menu': isActiveMenu('(price-lists)')}, {'open': isActiveMenu(pricelists_paths)}]" v-if="is_master === true || (permissions.indexOf('144') >= 0 && features.indexOf('price_lists') >= 0)">
                            <router-link :to="{path: '/price-lists', query: { page: 1 }}" exact :class="['nav-link', {'active': isActiveMenu(pricelists_paths)}]">
                                <i class="fas fa-comment-dollar"></i> Price Lists
                            </router-link>
                        </li>
                        <!-- productmappingcode_read = 64 -->
                        <li :class="['nav-item', 'link-master-data', {'active-menu': isActiveMenu('(product-mapping-codes)')}, {'open': isActiveMenu(productmapping_paths)}]" v-if="is_master === true || (permissions.indexOf('64') >= 0 && features.indexOf('product_mapping') >= 0)">
                            <router-link :to="{path: '/product-mapping-codes', query: { page: 1 }}" exact :class="['nav-link', {'active': isActiveMenu(productmapping_paths)}]">
                                <i class="fas fa-pencil-ruler"></i>Mapping
                            </router-link>
                        </li>
                    </ul>
                </li>
            </ul>
            <!-- END SETTINGS -->
            <!-- START PROFILE  -->
            <ul class="nav" v-show="current_top_menu === 'user profile'">
                <li class="nav-item" :class="{'active-menu': isActiveMenu('(dashboard)')}">
                    <router-link :to="{path: '/profile', }" exact class="nav-link">
                        <i class="fa fa-user"></i> Profile
                    </router-link>
                </li>
                <li class="nav-item" :class="{'active-menu': isActiveMenu('(dashboard)')}">
                    <router-link :to="{path: '/announcements/all', query: { page: 1 }}" exact :class="['nav-link', {'active': isActiveMenu(pricelists_paths)}]">
                        <i class="fas fa-bullhorn"></i> Announcements
                    </router-link>
                </li>
                <li class="nav-item" :class="{'active-menu': isActiveMenu('(dashboard)')}">
                    <a class="nav-link" href="#" v-on:click.prevent="logout"><i class="fa fa-lock"></i> Logout</a>
                </li>
            </ul>
            <!-- END PROFILE -->
        </nav>
    </div>
</template>

<script>
import swal from 'sweetalert2'
import _ from 'lodash'
export default {
  data () {
    return {
      permissions: (this.$cookies.isKey('om_session_permissions')) ? this.$cookies.get('om_session_permissions').split(',') : [],
      master_data_paths: [
        'retailers',
        'clients',
        'store-model',
        'products',
        'product-categories',
        'product-brands',
        'product-mapping-codes',
        'product-packings',
        'price-lists',
        'merchandisers',
        'promoter-rosters',
        'promoters'
      ],
      features: (this.$cookies.isKey('om_session_features') && this.$cookies.get('om_session_features') !== 'undefined') ? JSON.parse(this.$cookies.get('om_session_features')) : [],
      retailers_paths: ['/retailers', '/retailers/add', 'edit-retailers'],
      client_paths: ['/clients', '/clients/add', 'edit-client'],
      store_model_paths: ['/store-model', '/store-model/add', 'edit-store-model'],
      visit_paths: ['/visits', '/visits/add', 'edit-visit'],
      product_paths: ['/products', '/products/add', 'edit-product'],
      productpacking_paths: ['/product-packings', '/product-packings/add', 'edit-productpacking'],
      productcategory_paths: ['/product-categories', '/product-categories/add', 'edit-productcategory'],
      productbrand_paths: ['/product-brands', '/product-brands/add', 'edit-product-brand'],
      productmapping_paths: ['/product-mapping-codes', '/product-mapping-codes/add', 'edit-product-mapping-code'],
      pricelists_paths: ['/price-lists', '/price-lists/add', 'edit-product-price-list'],
      merchandiser_paths: ['/merchandisers', '/merchandisers/add', 'edit-merchandiser'],
      promoter_roster_path: ['/promoter-rosters', '/promoter-roster/add', 'promoter-roster/edit'],
      promoter_path: ['/promoters', '/promoter/add', '/promoter/edit'],
      planogram_path: ['/planograms', '/planograms/add', '/planograms/edit'],
      settings_path: ['settings', 'users', 'roles'],
      promoters_path: ['promoters_sales'],
      clientusers_path:['clientusers','clientusers/edit'],
      assignsupervisor_path:['assign-supervisor','assign-supervisor/add'],
      userinfo: (this.$cookies.isKey('om_session_info')) ? (this.$cookies.get('om_session_info')) : [],
      visit: ['visits', 'visits/calendar'],
      actions_url: ['visits', 'visit-calendar','promoter-rosters','promoter-calendar'],
      locations_url: ['locations', 'location-map'],
      inventories_url: ['inventories'],
      reports_url: [
        'visit-report2', 
        'photo-gallery-report', 
        'store-audit-report', 
        'task-report', 
        'historical-taskreport', 
        'no-visit-location-report', 
        'uncompleted-store-visits', 
        'master-visit-report', 
        'promoter-roster-report', 
        'non-clocked-employee-reports', 
        'salesreport', 
        'commission-report', 
        'customers', 
        'stock-take-reports', 
        'order-form-report', 
        'planogram-visit-reports', 
        'oos-report', 
        'stock-take-management-reports', 
        'stock-request-management-reports', 
        'stock-receipt-management-reports', 
        'stock-transfer-management-reports', 
        'stock-receipt-erp-management-reports', 
        'discrepancy-report',
        'sampling-reports',
        'stock-take-report-all-location',
        'planogram-reports-all-location'
    ],
      sales_settings_url: ['sales-target-location', 'sales-target-promoter'],
      manage_users_url: ['users', 'clientusers', 'assign-supervisor'],
      location_settings_url: ['clients', 'retailers', 'planograms'],
      project_settings_url: ['product-packings', 'product-categories', 'product-brands', 'products', 'store-model', 'price-lists', 'product-mapping-codes'],
      active_actions: false,
      active_locations: false,
      active_inventories: false,
      active_reports: false,
      active_sales_settings: false,
      active_getting_started: false,
      active_manage_users: false,
      active_product_settings: false,
      roles: (this.$cookies.isKey('om_session_roles')) ? JSON.parse(this.$cookies.get('om_session_roles')) : [],
      is_manager: false,
      is_merchandiser: false,
      is_client: false,
      is_promoter: false,
      current_top_menu: '',
      active_action : false,
      active_sampling_report: ['sampling-reports?'],
      active_visit : false,
      active_visit_report : false,
      active_promoters_report: false,
      active_stock_movement: false,
      active_location_settings: false,
      active_product_settings: false,
      active_sales_settings: false,
      active_company_settings: false,
      company_settings: false,
      active_getting_stated: false,
      getting_started_settings: [],
      plan: '',
      is_master: false,
      is_supervisor: false,
      sampling: 0
    }
  },
  beforeCreate() {
    this.permissions = (this.$cookies.isKey('om_session_permissions')) ? this.$cookies.get('om_session_permissions').split(',') : []
  },
  mounted: function() {
  },
  created () {
    var vue = this
    _.each(this.roles, function (item) {
      if (item.name === 'manager') {
        vue.is_manager = true
      }
      if (item.name === 'supervisor') {
        vue.is_manager = true
      }
      if (item.name === 'merchandiser') {
        vue.is_merchandiser = true
      }
      if (item.name === 'client') {
        vue.is_client = true
      }
      if (item.name === 'promoter') {
        vue.is_promoter = true
      }
      if (item.name === 'Sales Manager' || item.name === 'Sales and Data Controller' || item.name === 'Data Admin' || item.name === 'manager' || item.name === 'supervisor') {
        vue.is_master = true
      }
      if (item.name === 'supervisor') {
        vue.is_supervisor = true
      }
    })

    var company = (this.$cookies.isKey('om_session_company')) ? JSON.parse(this.$cookies.get('om_session_company')) : []
    this.permissions = (this.$cookies.isKey('om_session_permissions')) ? this.$cookies.get('om_session_permissions').split(',') : []
    if (Object.keys(company).length) {
      this.plan = (company) ? parseInt(company.plan_id) : null
      this.sampling = company.sampling
    }
  },
  watch: {
    '$route' (to, from) {
      var url = (this.$route.path).split('/')
      if (url[1] == 'profile') {
        this.current_top_menu = 'user profile'
      } else if(url[1] == 'settings') {
        this.current_top_menu = 'settings'
      } else {
        this.current_top_menu = this.$cookies.get('current_menu')
      }
      if (this.$cookies.get('om_session_previous_page') === 'welcome') {
        window.location.reload()
      }
      var path = (this.$route.path)
      if (url[1] !== 'login' && url[1] !== 'register' && url[1] !== 'signup' && url[1] !== 'welcome' && url[1] !== 'dashboard' && url[1] !== 'reset' && url[1] !== 'forgot' && path !== '//user/oauth/check') {
        this.permissions = (this.$cookies.isKey('om_session_permissions')) ? this.$cookies.get('om_session_permissions').split(',') : []
        if (this.permissions.length === 0 ) {
          this.$cookies.remove('om_session')
          this.$cookies.remove('om_session_info')
          this.$cookies.remove('om_session_company')
          this.$cookies.remove('om_session_permissions')
          this.$cookies.remove('om_session_roles')
          this.$cookies.remove('om_session_last')
          this.$cookies.remove('current_menu')
          swal({
            title: 'Session Expired !',
            text: '',
            type: 'warning',
            showCancelButton: false,
            allowOutsideClick: false
          }).then(function () {
            this.$router.push('/login')
          }.bind(this), function (dismiss) {
          if (dismiss === 'cancel') {
              this.$router.push('/login')
            }
          }.bind(this)) // end swal
        }
      }

      this.active_locations = false
      this.active_inventories = false
      this.active_actions = false
      this.active_reports = false

      if (this.actions_url.includes(url[1])) {
        this.active_actions = true
      } else if (this.locations_url.includes(url[1])) {
        this.active_locations = true
      } else if (this.inventories_url.includes(url[1])) {
        this.active_inventories = true
      } else if (this.reports_url.includes(url[1])) {
        this.active_reports = true
      } else if (this.sales_settings_url.includes(url[1])) {
        this.active_sales_settings = true
      } else if (this.manage_users_url.includes(url[1])) {
        this.active_manage_users = true
      } else if (this.location_settings_url.includes(url[1])) {
        this.active_location_settings = true
      } else if (this.project_settings_url.includes(url[1])) {
        this.active_product_settings = true
      } else{
      }

      if (this.actions_url.includes(url[1])) {
        this.active_actions = true
      }

    }
  },
  methods: {
    isActiveMenuGroup (menuitems = []) {
      for (var i in menuitems) {
        let pattern = new RegExp(menuitems[i])
        if (pattern.test(this.$route.path)) {
          return true
        }
      }
    },
    isActiveMenu (path) {
      var pattern = new RegExp(path)
      return pattern.test(this.$route.path)
    },
    logout: function (event) {
      this.$http.post(process.env.API_ENDPOINT + '/user/logout?token=' + this.$cookies.get('om_session')).then((response) => {
        // response
      }, (response) => {
        // fail
      })

      this.$cookies.remove('om_session')
      this.$cookies.remove('om_session_info')
      this.$cookies.remove('om_session_company')
      this.$cookies.remove('om_session_permissions')
      this.$cookies.remove('om_session_roles')
      this.$cookies.remove('om_session_last')
      this.$router.go('/login')
    }
  }
}
</script>
<style>
    body:not(.top-nav) .sidebar ul.nav li.nav-item.active-menu {
        background: #03BFA5 !important;
    }
    body:not(.top-nav) .sidebar ul.nav li.nav-item a:hover {
        background: #04d1b2 !important;
    }
    body:not(.top-nav) .sidebar ul.nav li.nav-item.active-menu a.nav-link i {
        border-right: none;
    }
    span.nav-title {
        overflow: hidden;
        white-space:nowrap;
        text-overflow:ellipsis;
        width:140px;
        display:inline-block;
        margin-bottom: -5px;
    }
</style>



// WEBPACK FOOTER //
// Sidebar.vue?409d63c0